import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/mujeeb_pro.png";
// import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I am a passionate Full Stack Web Developer with hands-on
              experience in building modern, scalable, and responsive web
              applications.
              <br />
              <br />
              My expertise lies in developing full-stack solutions using
              <b className="purple">
                {" "}
                MongoDB, Express.js, React.js, and Node.js{" "}
              </b>
              <br />
              <br />
              My areas of interest also extend to &nbsp; cloud deployment,
              performance optimization, and exploring emerging technologies like
              <b className="purple"> blockchain </b> and
              <b className="purple"> AI-driven solutions.</b>
              <br />
              <br />I enjoy designing and implementing efficient backend
              systems, creating engaging user interfaces, and integrating APIs
              to deliver seamless digital experiences.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <img src={myImg} className="img-fluid" alt="avatar" />
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/mujeebkhan3771"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              {/* <li className="social-icons">
                <a
                  href="https://twitter.com/mujeebkhan3771"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li> */}
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/mujeebkhan3771/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              {/* <li className="social-icons">
                <a
                  href="https://www.instagram.com/mujeebkhan3771"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li> */}
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
